@if(show) {
  <div class="full">
    <div class="dialog-confirm" cdkDrag cdkDragBoundary=".drag-limit">
      <div class="title">{{(titleMessage? titleMessage.label : 'action.general_confirm')| translate}}</div>
      <div class="content">
        {{(confirmMessage? confirmMessage.label : 'common.confirm.content') | translate}}
      </div>
      <div class="btn-area">
        <button class="cancel-btn" (click)="close()">{{ 'common.confirm.btn.no' | translate }}</button>
        <button class="save-btn" (click)="confirmAction()">{{ 'common.confirm.btn.yes' | translate }}</button>
      </div>
    </div>
  </div>
}

<ng-content></ng-content>
